<template>
    <BaseModalNew :title="'Update profile'" @close="closeModal">
        <template #modalContent>
            <div class="profile-modal-wrapper bm-modal-content-wrapper">
                <div class="flex flex-col gap-6">
                    <!-- Account Information -->
                    <div class="flex flex-col py-4 px-6 rounded-xl">
                        <div class="flex items-center justify-between">
                            <p class="text-lg font-semibold pr-section-heading">Account Information</p>
                        </div>
                        <div class="flex flex-col mt-8">
                            <!-- <div class="flex justify-left">
                                <img src="@/assets/images/avatar.png" alt="avatar" class="h-56 w-56 rounded-md" />
                            </div> -->
                            <div class="flex flex-col">
                                <label for="username" class="text-base text-white mt-6">Username</label>
                                <input type="text" placeholder="Username" v-model="form.username"
                                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" />
                            </div>
                            <div class="flex flex-col">
                                <label for="email" class="text-base text-white mt-6">Email</label>
                                <input type="text" placeholder="your@example.com" v-model="form.email"
                                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" />
                            </div>
                        </div>
                    </div>

                    <!-- User Information -->
                    <div class="flex flex-col py-4 px-6 rounded-xl">
                        <div class="flex items-center justify-between">
                            <p class="text-lg font-semibold pr-section-heading">User Information</p>
                        </div>
                        <div class="flex flex-col">
                            <div class="flex flex-col">
                                <label for="firstname" class="text-base text-white mt-6">First Name</label>
                                <input type="text" placeholder="John" v-model="form.firstName"
                                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" />
                            </div>
                            <div class="flex flex-col">
                                <label for="lastname" class="text-base text-white mt-6">Last Name</label>
                                <input type="text" placeholder="Doe" v-model="form.lastName"
                                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none" />
                            </div>
                            <!-- <div class="flex flex-col">
                                <label for="bio" class="text-base text-white mt-6">Bio</label>
                                <textarea placeholder="Your Bio" v-model="form.bio"
                                    class="flex-1 bg-transparent text-white placeholder-slate-500 focus:outline-none resize-none h-24"></textarea>
                            </div> -->
                        </div>
                    </div>

                    <!-- DID Information -->
                    <div class="flex flex-col py-4 px-6 rounded-xl">
                        <div class="flex items-center justify-start mt-6">
                            <button @click="handleUpdateUserInfo">
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </BaseModalNew>
</template>

<script>
import BaseModalNew from "@/components/common/BaseModalNew.vue";

export default {
    name: 'UpdateProfileModal',
    props: ['closeModal'],
    components: {
        BaseModalNew,
    },
    data() {
        return {
            form: {
                username: "",
                email: "",
                firstName: "",
                lastName: "",
            },
        };
    },
    async mounted() {
        await this.verifyAuthToken();
        this.form = {
            username: this.activeUserInfo.username || '',
            email: this.activeUserInfo.email || '',
            firstName: this.activeUserInfo.firstName,
            lastName: this.activeUserInfo.lastName || '',
        };
    },
    computed: {
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        },
    },
    methods: {
        verifyAuthToken() {
            this.$store.dispatch('auth/v2verifyAuthToken');
        },
        async handleUpdateUserInfo() {
            const payload = this.getChangedFields(this.form, this.activeUserInfo);

            if (Object.keys(payload).length === 0) {
                this.$vs.notify({
                    title: "No Changes",
                    text: "No fields were modified.",
                    color: "warning",
                });
                return;
            }

            if (("firstName" in payload && payload.firstName.trim() === "")) {
                this.$vs.notify({
                    title: "Required Fields Missing",
                    text: "First Name cannot be empty.",
                    color: "danger",
                });
                return;
            }

            if (("username" in payload && payload.username.trim() === "")) {
                this.$vs.notify({
                    title: "Required Fields Missing",
                    text: "Username cannot be empty.",
                    color: "danger",
                });
                return;
            }

            this.$store
                .dispatch("auth/v2updateUserInfo", payload)
                .then((response) => {
                    this.$vs.notify({
                        title: "Success!",
                        text: "Profile details updated",
                        color: "success",
                    });
                    this.$emit('bindUpdatedUserData');
                    this.closeModal();
                })
                .catch((e) => {
                    console.log(e.response);
                });
        },
        getChangedFields(newData, oldData) {
            const changed = {};
            for (const key in newData) {
                // Only include if the value is different and not null/undefined
                if (newData[key] !== oldData[key] && newData[key] != null) {
                    changed[key] = newData[key];
                }
            }
            return changed;
        },
    },
}
</script>

<style scoped>
*:not(i) {
    /* font-family: 'Karla', sans-serif !important; */
    font-family: 'Rethink Sans' !important;
}

.profile-modal-wrapper {
    max-height: 70vh;
    overflow-y: scroll;
    width: 580px;
}

.pr-section-heading {
    color: rgba(255, 255, 255, 50%);
}

input,
input[type="text"],
textarea {
    flex: 1;
    padding: 10px;
    border-radius: 8px;
    border: none;
    outline: none;
    background-color: #15161F;
    color: #FFFFFF;
    font-size: 1rem;
    border: 1px solid rgba(255, 255, 255, 10%);
}

button {
    background-color: #D3CA57;
    border: none;
    padding: 10px 20px;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s ease;
    color: #000000;
}

button:hover {
    background-color: #ebe369;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.8;
}
</style>